<template>
  <div class="page-detail orders-service-create" v-loading="loading">
    <div class="title">
      下单
      <div>
        流程：
        <span :class="{ active: step === 1 }">1. 选择服务项目</span>
        <i>－</i>
        <span :class="{ active: step === 2 }">2. 确认订单信息</span>
        <i>－</i>
        <span>3. 提交订单</span>
        <div class="top-money-container">
          <span class="top-money">
            个人账户余额:
            <span class="money-detail">{{ olderMoney.person }}</span
            >元
          </span>
          <span class="top-money">
            基础补助余额:
            <span class="money-detail">{{ olderMoney.grant }}</span
            >元
          </span>
          <!-- <span class="top-money">
            孝善基金余额:
            <span class="money-detail">{{olderMoney.fund}}</span>元
          </span>-->
        </div>
      </div>
    </div>
    <div class="content" ref="content">
      <div class="info-block service-target">
        <div class="title">服务对象信息</div>
        <div class="sub-info row">
          <div class="field">
            <div class="label">老人信息</div>
            <div class="text">
              <div class="field">
                <div class="label">姓名</div>
                <div class="text">{{ info.name }}</div>
              </div>
              <div class="field">
                <div class="label">手机号</div>
                <div class="text">{{ info.phone }}</div>
              </div>
              <div class="field">
                <div class="label">身份证</div>
                <div class="text">{{ info.idCard }}</div>
              </div>
              <div class="field">
                <div class="label">年龄</div>
                <div class="text">{{ info.age }}</div>
              </div>
              <div class="field">
                <div class="label">性别</div>
                <div class="text">{{ info.gender === "1" ? "女" : "男" }}</div>
              </div>
              <div class="field">
                <div class="label">老人类型</div>
                <div class="text">{{ getNameOfOldManType(info.type) }}</div>
              </div>
              <div class="field">
                <div class="label">地址</div>
                <div class="text">{{ info.residenceAddress }}</div>
              </div>
              <div class="field">
                <div class="label">标签</div>
                <div class="text">{{ info.tagNames }}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="label">子女信息</div>
            <div class="text">
              <div class="field" v-for="item in contacts" :key="item.gid">
                <div class="label">{{ item.name }}</div>
                <div class="text">
                  <span>{{ item.relationship }}</span>
                  <span>{{ item.phone }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-block service-info">
        <div class="title">服务信息</div>
        <div class="sub-info edit">
          <div class="field">
            <div class="label">服务项目</div>
            <div class="text">
              <el-button
                v-if="step === 1"
                type="default"
                size="mini"
                @click="selectService"
                >选择服务项目</el-button
              >
              <p class="service-business-info" v-if="service">
                <span>{{ service.providerName }}</span>
                <span>地址：{{ service.provider.address }}</span>
                <span>电话：{{ service.provider.cTelPhone }}</span>
                <span>{{ service.serviceName }}</span>
              </p>
            </div>
          </div>
          <div class="field">
            <div class="label">服务价格</div>
            <div class="text">
              <table
                class="has-selected"
                :class="{ disabled: step === 2 }"
                v-if="service"
              >
                <tbody>
                  <tr
                    v-for="sku in service.skus || []"
                    :class="{ selected: sku.selected }"
                    :key="sku.gid"
                    @click="selectSku(sku)"
                  >
                    <td></td>
                    <td>{{ sku.name }}</td>
                    <td>{{ sku.price }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="field">
            <div class="label">服务方式</div>
            <div class="text">
              {{ service && service.serviceMode }}
            </div>
          </div>
          <div class="field">
            <div class="label">服务单位</div>
            <div class="text">
              {{ service && getNameOfUnitTime(service.unitOfTime) }}
            </div>
          </div>
          <div class="field">
            <div class="label">服务时长</div>
            <div class="text">{{ service && service.unitFrequencyTime }}</div>
          </div>
          <div class="field">
            <div class="label">服务周期</div>
            <div class="text">{{ service && service.cycle | cycleFilter }}</div>
          </div>
          <div class="field">
            <div class="label">服务次数</div>
            <div class="text">{{ service && service.frequency }}</div>
          </div>

          <!--<div class="field">-->
          <!--<div class="label">基础补贴支付</div>-->
          <!--<div class="text">160元</div>-->
          <!--</div>-->
          <!--<div class="field">-->
          <!--<div class="label">孝善基金支付</div>-->
          <!--<div class="text">20元</div>-->
          <!--</div>-->
          <!--<div class="field">-->
          <!--<div class="label">个人钱包支付</div>-->
          <!--<div class="text">20元</div>-->
          <!--</div>-->
        </div>
        <div class="sub-info edit">
          <div class="field">
            <div class="label">选择服务数量</div>
            <div class="text">
              <el-input-number
                size="mini"
                v-model="frequency"
                :min="1"
                :max="200"
              ></el-input-number>
            </div>
          </div>
          <div class="field">
            <div class="label">预约开始时间</div>
            <div class="text">
              <service-time-selector
                :times="times"
                v-if="step === 1"
                :source-object="remark"
              ></service-time-selector>
              <template v-else
                >{{ remark.date }}&nbsp;{{ remark.time }}</template
              >
            </div>
          </div>
          <div class="field">
            <div class="label">服务地址</div>
            <div class="text">
              <el-input
                v-if="step === 1"
                disabled
                v-model="remark.addr"
                size="mini"
              ></el-input>
              <template v-else>{{ remark.addr }}</template>
            </div>
          </div>
          <div class="field">
            <div class="label">联系电话</div>
            <div class="text">
              <el-input
                v-if="step === 1"
                v-model="remark.tel"
                size="mini"
              ></el-input>
              <template v-else>{{ remark.tel }}</template>
            </div>
          </div>
          <div class="field">
            <div class="label">备注</div>
            <div class="text">
              <el-input
                v-if="step === 1"
                v-model="remark.remark"
                size="mini"
              ></el-input>
              <template v-else>{{ remark.remark }}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <el-button type="primary" size="small" v-if="step === 1" @click="doNext"
        >下一步</el-button
      >
      <template v-else>
        <el-button type="default" size="small" @click="step = 1"
          >上一步</el-button
        >
        <el-button type="primary" size="small" @click="submit"
          >提交订单</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Promise from 'promise'
import qs from 'qs'
import ServiceTimeSelector from '@/components/partial/ServiceTimeSelector'

export default {
  components: { ServiceTimeSelector },
  data () {
    return {
      olderMoney: {},
      loading: false,
      step: 1,
      info: {},
      contacts: [],
      service: null,
      skus: [],
      remark: {
        time: '',
        addr: '',
        tel: '',
        remark: ''
      },
      times: ['08:00-12:00', '12:00-20:00'],
      frequency: 1
    }
  },
  computed: {
    tel () {
      return this.$route.query.tel || ''
    },
    olderGid () {
      return this.$route.query.oneOldGid || ''
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true

      // 老人详细信息
      if (this.olderGid) {
        this.Service.call('theold/detail', 'GET', { gid: this.olderGid })
          .then(data => {
            if (data && data.gid) {
              this.info = data
              this.remark.addr = data.householdRegister
              this.remark.tel = data.phone || ''
              this.Service.call('usercontact', 'GET', { gid: this.info.gid })
                .then(data => {
                  this.contacts = data || []
                  this.Service.call('theoldstatistics/account', 'GET', {
                    theOldGid: this.olderGid
                  }).then(res => {
                    this.olderMoney = { ...res }
                  })
                })
                .catch(() => {})
                .finally(() => {
                  this.loading = false
                })
            } else {
              this.loading = false
              this.routeReplace('/orders/service')
            }
          })
          .catch(() => {
            this.loading = false
            this.routeReplace('/orders/service')
          })
      } else if (this.tel) {
        this.Service.call('theold/detail/byphone', 'GET', { phone: this.tel })
          .then(data => {
            if (data && data.gid) {
              this.info = data
              this.remark.addr = data.householdRegister
              this.remark.tel = data.phone || ''
              this.Service.call('usercontact', 'GET', { gid: this.info.gid })
                .then(data => {
                  this.contacts = data || []
                  this.Service.call('theoldstatistics/account', 'GET', {
                    theOldGid: this.info.gid
                  }).then(res => {
                    this.olderMoney = { ...res }
                  })
                })
                .catch(() => {})
                .finally(() => {
                  this.loading = false
                })
            } else {
              this.loading = false
              this.routeReplace('/orders/service')
            }
          })
          .catch(() => {
            this.loading = false
            this.routeReplace('/orders/service')
          })
      }
    },
    selectService () {
      this.modal('SelectDaycareModal', this.info.gid).promise.then(service => {
        if (service) {
          this.loading = true
          // 获取provider以及skus
          Promise.all([
            this.Service.call('serviceprovider/detail', 'GET', {
              gid: service.providerId
            }).then(data => {
              service.provider = data || {}
            }),
            this.Service.call('serviceitemsku', 'GET', {
              serviceitemgid: service.gid
            }).then(data => {
              service.skus = data || []
              for (let i = 0; i < service.skus.length; i++) {
                service.skus[i].selected = i === 0
              }
            })
          ]).finally(() => {
            this.loading = false
            this.service = service
            this.skus = service.skus
          })
        }
      })
    },
    selectSku (sku) {
      if (this.step === 2) return
      for (let item of this.service.skus) {
        this.$set(item, 'selected', item === sku)
      }
      this.$set(this.service, 'skus', [...this.service.skus])
    },
    doNext () {
      if (!this.service) {
        this.$message.error('请选择服务项目')
        return
      }
      if (!this.remark.date) {
        this.$message.error('请填写预约开始日期')
        return
      }
      if (!this.remark.time) {
        this.$message.error('请填写预约开始时间')
        return
      }
      if (!this.remark.addr) {
        this.$message.error('请填写服务地址')
        return
      }
      if (!this.remark.tel) {
        this.$message.error('请填写联系电话')
        return
      }
      this.step = 2
      this.$refs.content.scrollTop = 0
    },
    submit () {
      if (this.loading == true) {
        return
      }
      let remark = [
        this.remark.date + ',' + this.remark.time || '',
        this.remark.addr || '',
        this.remark.tel || '',
        this.remark.remark || ''
      ].join(',')
      let curSku = _.find(this.service.skus, e => e.selected)
      let data = [
        {
          serviceItemGid: this.service.gid,
          serviceItemName: this.service.serviceName,
          remark,
          skus: [
            {
              serviceItemSkuGid: curSku && curSku.gid,
              serviceItemSkuName: curSku && curSku.name,
              num: this.frequency
            }
          ]
        }
      ]
      this.loading = true
      this.Service.call(
        'order',
        'POST',
        qs.stringify({
          type: 1,
          serviceMode: this.service.serviceMode,
          serviceItemSkus: JSON.stringify(data),
          theOldGid: this.info.gid
        }),
        null,
        null,
        'json',
        'application/x-www-form-urlencoded'
      )
        .then(res => {
          console.log('createOrder', res)
          if (res.data.code === 0) {
            this.$message.success('订单提交成功')
            this.$router.push('/orders/service')
          } else {
            this.$message.error(`订单创建失败:${res.data.des}`)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    $route () {
      this.loadData()
    }
  }
}
</script>
<style lang="scss" scoped>
.top-money-container {
  display: inline-block;
  border-left: 2px solid #909399;
  margin-left: 20px;
  .top-money {
    margin-left: 25px;
    color: black;
    .money-detail {
      font-weight: bold;
      font-size: 16px;
      color: #67c23a;
    }
  }
}
</style>